// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class EndTurnAction implements flatbuffers.IUnpackableObject<EndTurnActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EndTurnAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEndTurnAction(bb:flatbuffers.ByteBuffer, obj?:EndTurnAction):EndTurnAction {
  return (obj || new EndTurnAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEndTurnAction(bb:flatbuffers.ByteBuffer, obj?:EndTurnAction):EndTurnAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EndTurnAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameEndTurn;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startEndTurnAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameEndTurn);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endEndTurnAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEndTurnAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  EndTurnAction.startEndTurnAction(builder);
  EndTurnAction.addType(builder, type);
  EndTurnAction.addPlayerId(builder, playerId);
  return EndTurnAction.endEndTurnAction(builder);
}

unpack(): EndTurnActionT {
  return new EndTurnActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: EndTurnActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class EndTurnActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameEndTurn,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EndTurnAction.createEndTurnAction(builder,
    this.type,
    this.playerId
  );
}
}
